export default function hourglassBottomIconSvg ({ size, color = '#3D5170' } = {}) {
  if (size === 'lg') {
    return `<svg width="58" height="58" viewBox="0 0 58 58" fill="${color}" xmlns="http://www.w3.org/2000/svg">
<path d="M43.5 53.1666L43.4758 38.6666L33.8333 28.9999L43.4758 19.3091L43.5 4.83325H14.5V19.3333L24.1667 28.9999L14.5 38.6424V53.1666H43.5ZM19.3333 18.1249V9.66659H38.6667V18.1249L29 27.7916L19.3333 18.1249Z" />
</svg>`
  }

  return `<svg width="18" height="18" viewBox="0 0 18 18" fill="${color}" xmlns="http://www.w3.org/2000/svg">
<path d="M13.5 16.5L13.4925 12L10.5 9L13.4925 5.9925L13.5 1.5H4.5V6L7.5 9L4.5 11.9925V16.5H13.5ZM6 5.625V3H12V5.625L9 8.625L6 5.625Z" />
</svg>`
}
